import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import CookieConsent from "@/components/CookieConsent";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import { useAuth } from "@/context/AuthContext";

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <AnalyticsTracker />
      <Navbar />
      <main className="flex-1 pb-16 lg:pb-0"><Outlet /></main>
      <Footer />
      <MobileNav />
      <CookieConsent />
    </div>
  );
}

export function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}
